export const showSearchLayer = visible => ({
  type: "SHOW_SEARCH_LAYER",
  visible
});

export const setLanguage = language => {
  let lng = language.toLowerCase();
  localStorage.setItem("lng", lng);

  return {
    type: "SET_LANGUAGE",
    language: lng
  };
};

export const setCurrentNavPage = currentNavPage => ({
  type: "SET_CURRENT_NAV_PAGE",
  currentNavPage
});

export const pushSourceToken = (sourceName, sourceToken) => ({
  type: "PUSH_SOURCE_TOKEN",
  sourceName,
  sourceToken
});

export const clearSourcesTokens = (sourceName, sourceToken) => ({
  type: "CLEAR_SOURCES_TOKENS"
});

export const setMenuDirection = direction => ({
  type: "SET_MENU_DIRECTION",
  direction
});



// WEBPACK FOOTER //
// ./src/actions/actions/params.js